/**
 * Open FairDialogs, innermost last. Escape closes only the top one — PrimeVue's
 * own `closeOnEscape` needs focus inside the panel, which a click elsewhere loses.
 */
const stack: symbol[] = []

export function pushFairDialog(id: symbol): void {
  removeFairDialog(id)
  stack.push(id)
}

export function removeFairDialog(id: symbol): void {
  const index = stack.indexOf(id)
  if (index !== -1) stack.splice(index, 1)
}

export function isTopFairDialog(id: symbol): boolean {
  return stack[stack.length - 1] === id
}
